<template>
	<div class="no-layout-container">
		<div v-if="canShowPageTitle()">
			<h1 class="page-title" v-html="getPageTitle"></h1>
		</div>

		<slot></slot>
	</div>
</template>



<script>
export default {
	name: "NoLayout",

	data() {
		return {

		};
	},



	mounted() {
		// console.log("NoLayout.mounted()");
	},




	// watch: {
	// 	$route(to, from) {
	// 		this.handleRoute();
	// 	}
	// },


	computed: {
		getPageTitle() {
			var _this = this;

			var pageTitleRaw = this.$route.meta.pageTitle;

			var pathParts = pageTitleRaw.split(' > ');

			var finalTitle = "";
			pathParts.forEach((part) => {
				if (finalTitle != "")
				{
					finalTitle = finalTitle + ' ' + _this.getPathSeparator() + ' ';	
				}
				finalTitle = finalTitle + part;
			});

			return finalTitle;
		},
	},

	methods: {
		getPathSeparator()
		{
			return '<i class="fas fa-long-arrow-alt-right"></i>';
		},	


		canShowPageTitle()
		{
			// When printing we still want to show the page title.
			if (this.$root.isPrinting) return true;

			return false;
		}
	}
}
</script>





<style lang="scss" scoped>
	.no-layout-container
	{
		/*
		TODO: This is a bit of a hack to layer the DIV rather than do a proper layout (#app root element has yellow background still set that we need to cover).
		*/
		width: 100%;
		height: 100%;
		background-color: white;

		// position: fixed;
		// top: 0;
		// left: 0;
		// right: 0;
		// bottom: 0;
	}
</style>